module.exports = __webpack_public_path__ + "media/bootstrap-icons/text-indent-left-434e6114.svg";